var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1218_128)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.4697,
    y: 35.8184,
    width: 27.3636,
    height: 27.3636,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1218_128)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9405 32.0331C32.9721 34.2646 28.0888 36.1095 28.0888 36.1328C28.0888 36.1562 32.9815 38.0026 38.9616 40.2359L49.8344 44.2965L53.9072 42.7726L57.98 41.2487L57.5109 41.044C57.2529 40.9314 55.4214 40.1747 53.4409 39.3623C51.4604 38.55 49.8484 37.878 49.8587 37.8689C49.869 37.8598 51.0985 37.3349 52.5908 36.7024L55.3042 35.5524L59.384 37.3759L63.464 39.1996L67.5226 37.6875C69.7548 36.8558 71.5811 36.1562 71.5809 36.1328C71.5808 36.0999 50.2392 28.1027 49.8775 28.0001C49.8306 27.9867 44.9089 29.8016 38.9405 32.0331ZM28.0217 51.1095L28.0432 63.3635L38.2354 67.1743L48.4275 70.985L48.4491 58.7725C48.4611 52.0556 48.4419 46.5352 48.4065 46.505C48.3712 46.4748 44.0053 44.8311 38.7045 42.8522C33.4037 40.8733 28.8267 39.1646 28.5334 39.0549L28 38.8556L28.0217 51.1095ZM67.5751 40.3851L63.5238 41.8991L63.4812 45.322L63.4386 48.7449L60.7519 49.7519C59.2743 50.3057 58.0562 50.7592 58.0449 50.7596C58.0337 50.7601 58.0145 49.2336 58.0023 47.3672L57.98 43.9739L54.611 45.2327L51.2421 46.4914L51.2205 58.7457L51.1989 71L51.7323 70.8007C52.0256 70.6909 56.6026 68.9822 61.9033 67.0033C67.2041 65.0245 71.57 63.3807 71.6053 63.3505C71.6407 63.3204 71.6599 57.8001 71.648 51.0833L71.6264 38.871L67.5751 40.3851ZM33.4784 59.9582L33.5018 61.4167L36.1884 62.4236C37.6661 62.9774 38.8856 63.4309 38.8984 63.4313C38.9112 63.4319 38.9112 62.7759 38.8984 61.9738L38.8751 60.5152L36.1884 59.5083C34.7108 58.9546 33.4913 58.501 33.4784 58.5006C33.4656 58.5001 33.4656 59.156 33.4784 59.9582Z",
    fill: "url(#paint1_linear_1218_128)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9405 32.0331C32.9721 34.2646 28.0888 36.1095 28.0888 36.1328C28.0888 36.1562 32.9815 38.0026 38.9616 40.2359L49.8344 44.2965L53.9072 42.7726L57.98 41.2487L57.5109 41.044C57.2529 40.9314 55.4214 40.1747 53.4409 39.3623C51.4604 38.55 49.8484 37.878 49.8587 37.8689C49.869 37.8598 51.0985 37.3349 52.5908 36.7024L55.3042 35.5524L59.384 37.3759L63.464 39.1996L67.5226 37.6875C69.7548 36.8558 71.5811 36.1562 71.5809 36.1328C71.5808 36.0999 50.2392 28.1027 49.8775 28.0001C49.8306 27.9867 44.9089 29.8016 38.9405 32.0331ZM28.0217 51.1095L28.0432 63.3635L38.2354 67.1743L48.4275 70.985L48.4491 58.7725C48.4611 52.0556 48.4419 46.5352 48.4065 46.505C48.3712 46.4748 44.0053 44.8311 38.7045 42.8522C33.4037 40.8733 28.8267 39.1646 28.5334 39.0549L28 38.8556L28.0217 51.1095ZM67.5751 40.3851L63.5238 41.8991L63.4812 45.322L63.4386 48.7449L60.7519 49.7519C59.2743 50.3057 58.0562 50.7592 58.0449 50.7596C58.0337 50.7601 58.0145 49.2336 58.0023 47.3672L57.98 43.9739L54.611 45.2327L51.2421 46.4914L51.2205 58.7457L51.1989 71L51.7323 70.8007C52.0256 70.6909 56.6026 68.9822 61.9033 67.0033C67.2041 65.0245 71.57 63.3807 71.6053 63.3505C71.6407 63.3204 71.6599 57.8001 71.648 51.0833L71.6264 38.871L67.5751 40.3851ZM33.4784 59.9582L33.5018 61.4167L36.1884 62.4236C37.6661 62.9774 38.8856 63.4309 38.8984 63.4313C38.9112 63.4319 38.9112 62.7759 38.8984 61.9738L38.8751 60.5152L36.1884 59.5083C34.7108 58.9546 33.4913 58.501 33.4784 58.5006C33.4656 58.5001 33.4656 59.156 33.4784 59.9582Z",
    stroke: "url(#paint2_linear_1218_128)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1218_128",
    x: 25.849,
    y: 25.85,
    width: 47.9523,
    height: 47.4104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1218_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1218_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1218_128",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1218_128",
    x1: 32.6712,
    y1: 31.9673,
    x2: 79.485,
    y2: 56.5742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1218_128",
    x1: 53.4634,
    y1: 35.1667,
    x2: 69.4211,
    y2: 72.9654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.a7219daafeff583373b39667499338f5.svg";
export { ForwardRef as ReactComponent };